import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getCommentsoldOAuthUrl = {
  name: "getCommentsoldOAuthUrl" as const,
  input: z.object({
    product: createEnum(CommentsoldIntegrationProduct),
    isStaging: z.boolean(),
    stagingEnv: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};
